"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const security_error_1 = require("./security-error");
/**
 * Exception thrown when a not allowed class property is used in a template.
 *
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingSandboxSecurityNotAllowedPropertyError extends security_error_1.TwingSandboxSecurityError {
    constructor(message, className, propertyName, lineno = -1, filename = null) {
        super(message, lineno, filename);
        this.className = className;
        this.propertyName = propertyName;
        this.name = 'TwingSandboxSecurityNotAllowedPropertyError';
    }
    getClassName() {
        return this.className;
    }
    getPropertyName() {
        return this.propertyName;
    }
}
exports.TwingSandboxSecurityNotAllowedPropertyError = TwingSandboxSecurityNotAllowedPropertyError;
